import { createRouter, createWebHistory } from 'vue-router';
import FrontLayout from '@/components/FrontLayout';
import DashboardLayout from '@/components/DashboardLayout';
import store from '@/store';
const routes = [
 
  {
    path: '/',
    component: FrontLayout,
    children:[
      {
        path: '/',
        name: 'Index',
        // meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "index" */ '@/views/Front/Index.vue')
      },
      {
        path: '/:link?',
        name: 'LinkDetail',
        component: () => import('@/views/Front/LinkDetail.vue'),
        meta: { isSubdomain: true },
      },
      {
        path: '/error/:status/:msg',
        name: 'Error',
        component: () => import(/* webpackChunkName: "error" */ '@/views/Front/Error.vue')
      },
      {
        path: '/login',
        name: 'Login',
        meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "login" */ '@/views/Auth/Login.vue')
      },
      {
        path: '/register',
        name: 'Register',
        meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "register" */ '@/views/Auth/Register.vue')
      },
      {
        path: '/forgot-password',
        name: 'ForgotPassword',
        meta: { requiresLogin: true },
        component: () => import(/* webpackChunkName: "forgot-password" */ '@/views/Auth/ForgotPassword.vue')
      },
      
    ]
  },

  {
    path: '/dashboard',
    meta: {requiresAuth: true},
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: () => import(/* webpackChunkName: "dashboard" */ '@/views/Panel/Dashboard.vue')
      },
      {
        path: '/roles',
        name: 'Role',
        component: () => import(/* webpackChunkName: "roles" */ '@/views/Panel/Role.vue')
      },
      {
        path: '/permissions',
        // meta: {hasProfile: store.state.user.has_profile},
        name: 'Permission',
        component: () => import(/* webpackChunkName: "permissions" */ '@/views/Panel/Permission.vue')
      },
      {
        path: '/users',
        // meta: {hasProfile: store.state.user.has_profile},
        name: 'User',
        component: () => import(/* webpackChunkName: "users" */ '@/views/Panel/User.vue')
      },
      {
        path: '/templates',
        // meta: {hasProfile: store.state.user.has_profile},
        name: 'Template',
        component: () => import(/* webpackChunkName: "templates" */ '@/views/Panel/Template.vue')
      },
      {
        path: '/profile',
        name: 'Profile',
        component: () => import(/* webpackChunkName: "profile" */ '@/views/Panel/Profile.vue')
      },
      {
        path: '/comments',
        name: 'Comment',
        component: () => import(/* webpackChunkName: "comments" */ '@/views/Panel/Comment.vue')
      },
      {
        path: '/faqs',
        name: 'Faq',
        component: () => import(/* webpackChunkName: "faqs" */ '@/views/Panel/Faq.vue')
      },
      {
        path: '/change-password',
        meta: {hasProfile: store.state.user.has_profile},
        name: 'ChangePassword',
        component: () => import(/* webpackChunkName: "change-password" */ '@/views/Panel/ChangePassword.vue')
      },
      {
        path: '/text-messages',
        name: 'TextMessage',
        component: () => import(/* webpackChunkName: "text-messages" */ '@/views/Panel/TextMessage.vue')
      },
    ]

  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior () {
    return { top: 0 };
  }
})

async function checkExpireCookie(){
  let expireAt = parseInt(store.getters.getCookie('expire_token'));
  let now = (new Date()).getTime();
  expireAt = isNaN(expireAt) ? now : expireAt;
  if(expireAt > now ){
    await store.dispatch('setCookie', 'expire_token')
  }else{
    store.commit('clearStorage')
  }
}

router.beforeEach(async (to,from,next)=>{

  store.state.toggleSideBar = false;


  await checkExpireCookie();
  if(to.matched.length <= 0){
    next({name:'Error', params:{status:'404', msg:'صفحه مورد نظر پیدا نشد'}})
  }

  // if(to.meta.requiresAuth === true){
  //   await store.dispatch('checkToken')
  // }
  if(to.meta.requiresLogin && store.getters.getToken !== null){
    next({name:'Index'});
  }else if(to.meta.requiresAuth && !store.getters.getToken){
    next({name:'Index'});
  }else{
    next();
  }

});

export default router
